import * as Sentry from "@sentry/react";

import { addToast, nextId, removeToast } from "../actions/toastActions";

function statusDescription(code: number): string {
  switch (code) {
    case 504:
      return "Gateway Timeout.";
    case 503:
      return "Service Unavailable.";
    case 502:
      return "Bad Gateway.";
    case 501:
      return "Not Implemented.";
    case 500:
      return "Internal Server Error.";
    case 405:
      return "Method Not Allowed.";
    case 404:
      return "Not Found";
    case 403:
      return "Forbidden.";
    case 401:
      return "Unauthorized.";
    case 400:
      return "Bad Request";
    default:
      return "Unspecified.";
  }
}

const errorTitle = (action: any) => {
  const error = action?.payload?.error || action?.payload;
  if (error?.status)
    return `${error.status} Error: ${statusDescription(error.status)}`;
  if (error?.message) return `Error: ${error.message}`;

  return "Error: Unknown";
};

const errorMessage = (action: any) => {
  const error = action?.payload?.error || action?.payload;
  const body = error?.body || error?.response;

  if (body) {
    if (body.detail) return body.detail;
    if (typeof body === "string") return body;
  }

  console.error("Unable to determine error message for action", action);
  return "Unknown error";
};

const errorMessageDetails = (action: any) => {
  const error = action?.payload?.error || action?.payload;
  const details = [];
  if (action?.type) details.push(`<td>ACTION:</td><td>${action.type}</td>`);
  if (error?.url) details.push(`<td>URL:</td><td>${error.url}</td>`);
  if (action?.requestKey)
    details.push(`<td>REQUEST KEY:</td><td>${action.requestKey}</td>`);
  if (details.length < 1) return "";

  return (
    "<code class='toast__error-details'><table><tbody><tr>" +
    details.join("</tr><tr>") +
    "</tr></tbody></table></code>"
  );
};

const errorReporter = (store: any) => (next: any) => (action: any) => {
  next(action);
  if (action.error && !action.meta?.nonfatal) {
    if (window.location.hostname !== "localhost") {
      // dev, stage, or prod
      Sentry.addBreadcrumb({
        type: "API Exception: " + action.payload?.type,
        level: "error",
        category: process.env.REACT_APP_VPC_NAME,
        message: action.payload.message,
        timestamp: Date.now(),
      });
      Sentry.captureException(action.payload.error || action.payload);
    }

    // TOASTS
    const id = nextId();

    store.dispatch(
      addToast(
        {
          kind: "danger",
          title: errorTitle(action),
          message: errorMessage(action) + errorMessageDetails(action),
          allowHtml: true,
        },
        id
      )
    );

    setTimeout(() => {
      store.dispatch(removeToast(id));
    }, 10000);
  }
};

export default errorReporter;
